import React from 'react'
import { inject, observer } from 'mobx-react'
import Name from '../common/Name'
import CopyGeometryButton from 'components/common/tooltips/CopyGeometryButton'
import MoveGeometryButton from 'components/common/tooltips/MoveGeometryButton'
import DeleteItemPrompt from 'components/tools/item/DeleteItemPrompt'
import Rename from '../common/Rename'
import { trackValue } from 'utils.js'
import { shapeTypes } from '../../../constants'
import { withTranslation } from 'react-i18next'
import ExportKMZButton from 'components/common/tooltips/ExportKMZButton'
import ProBadge from 'components/common/ProBadge'
import { startProCheckout } from '../../../proCheckout'
import { HugeiconsIcon } from '@hugeicons/react'
import ColorButton from '../common/ColorButton'
import {
  CropIcon,
  PencilEdit01Icon,
  PaintBoardIcon,
  CenterFocusIcon,
  FileSpreadsheetIcon,
  Delete02Icon
} from '@hugeicons/core-free-icons'

import RenameTooltip from 'components/common/tooltips/RenameTooltip'
import SaveEditShapeTooltip from 'components/common/tooltips/SaveEditShapeTooltip'

const OwnedGeopolygon = ({ geopolygon, group, uiStore, selectionStore, t }) => {
  const isEditingThisShape = selectionStore.isEditing && selectionStore.editableShape && (
    selectionStore.editableShape === geopolygon ||
    (geopolygon.id != null && selectionStore.editableShape.id != null && String(geopolygon.id) === String(selectionStore.editableShape.id)) ||
    (geopolygon.inner_id != null && selectionStore.editableShape.inner_id != null && String(geopolygon.inner_id) === String(selectionStore.editableShape.inner_id))
  )
  const isItemActive = isEditingThisShape || (uiStore && typeof uiStore.isItemSelected === 'function' ? uiStore.isItemSelected(geopolygon, group) : false) || (
    selectionStore.item === geopolygon ||
    (geopolygon.id != null && selectionStore.item && selectionStore.item.id != null && String(selectionStore.item.id) === String(geopolygon.id)) ||
    (geopolygon.inner_id != null && selectionStore.item && selectionStore.item.inner_id != null && String(selectionStore.item.inner_id) === String(geopolygon.inner_id))
  )

  const editLabel = geopolygon.buffer || geopolygon.type === shapeTypes.POINT_BUFFER_SHAPE
    ? t('ITEM.EDIT_BUFFER', { defaultValue: 'Edit buffer' })
    : t('ITEM.EDIT_SHAPE', { defaultValue: 'Edit shape' })

  return (
    <div className='owned-geopolygon'>
      {
        geopolygon.renameForm.active
          ? (
            <Rename
              label={t('GEOPOLYGON.GEOPOLYGON')}
              {...trackValue(geopolygon.renameForm, 'name')}
              error={geopolygon.error}
              clearError={() => (geopolygon.error = null)}
              onSubmit={() => {
                uiStore.renameGeopolygon(
                  group,
                  geopolygon,
                  geopolygon.renameForm.name
                )
                !geopolygon.error && geopolygon.endRename()
              }}
              onCancel={() => geopolygon.endRename()}
            />
            )
          : (
            <Name
              label={t('GEOPOLYGON.GEOPOLYGON')}
              onClick={() => geopolygon.startRename()}
              name={geopolygon.name}
            />
            )
      }
      <section className='owned-geopolygon__list'>
        {isItemActive && (
          isEditingThisShape
            ? (
              <button
                className='edit-shape'
                onClick={(e) => {
                  e.stopPropagation()
                  uiStore.openClickTooltip({
                    allowMapClicks: true,
                    style: {
                      width: 340
                    },
                    position: 'right-start',
                    selector: '.tools.popup-menu',
                    text: (
                      <SaveEditShapeTooltip
                        title={t('GLOBAL.CONFIRM_SAVE', { defaultValue: 'Confirm Save' })}
                        itemName={geopolygon.name}
                        onSave={() => {
                          selectionStore.saveEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onCancel={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onClose={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                      />
                    )
                  })
                }}
              >
                <HugeiconsIcon icon={CropIcon} size={18} className='popup-menu__icon' />
                <span>{t('GLOBAL.CONFIRM_SAVE', { defaultValue: 'Save / Cancel' })}</span>
              </button>
              )
            : (
              <button
                className={`edit-shape ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
                onClick={(e) => {
                  e.stopPropagation()
                  if (uiStore.user && uiStore.user.type === 'starter') {
                    startProCheckout({ uiStore, t })
                    return
                  }
                  selectionStore.enableEdit(geopolygon, group)
                  uiStore.openClickTooltip({
                    allowMapClicks: true,
                    style: {
                      width: 340
                    },
                    position: 'right-start',
                    selector: '.tools.popup-menu',
                    text: (
                      <SaveEditShapeTooltip
                        title={editLabel}
                        itemName={geopolygon.name}
                        onSave={() => {
                          selectionStore.saveEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onCancel={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onClose={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                      />
                    )
                  })
                }}
              >
                <HugeiconsIcon icon={CropIcon} size={18} className='popup-menu__icon' />
                <span>{editLabel}</span>
                {uiStore.user && uiStore.user.type === 'starter' &&
                <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
              </button>
              )
        )}
        <button
          className={`rename ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
          onClick={(e) => {
            e.stopPropagation()
            if (uiStore.user && uiStore.user.type === 'starter') {
              startProCheckout({ uiStore, t })
              return
            }
            uiStore.openClickTooltip({
              style: {
                width: 340
              },
              position: 'right-start',
              selector: '.tools.popup-menu',
              text: (
                <RenameTooltip
                  title={t('GLOBAL.RENAME_REGION', { defaultValue: 'Rename region' })}
                  label={t('GLOBAL.REGION_NAME', { defaultValue: 'Region name' })}
                  initialValue={geopolygon.name}
                  onSubmit={(newName) => {
                    uiStore.renameGeopolygon(group, geopolygon, newName)
                    uiStore.hideClickTooltip()
                  }}
                  onClose={() => {
                    uiStore.hideClickTooltip()
                  }}
                />
              )
            })
          }}
        >
          <HugeiconsIcon icon={PencilEdit01Icon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.RENAME')}</span>
          {uiStore.user && uiStore.user.type === 'starter' &&
          <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
        </button>
        <ColorButton item={geopolygon} />
        <button onClick={e => {
          e.currentTarget.blur()
          uiStore.setBoundsToItem(geopolygon)
        }}
        >
          <HugeiconsIcon icon={CenterFocusIcon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.FIT_REGION')}</span>
        </button>
        <CopyGeometryButton
          lgIcon
          group={group}
          onSubmit={() => uiStore.copyGeopolygon(geopolygon, group)}
        />
        <MoveGeometryButton
          lgIcon
          group={group}
          onSubmit={() => uiStore.moveGeopolygon(geopolygon, group)}
        />
        <button
          key='btn-excel'
          className={uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}
          onClick={() => {
            if (uiStore.user && uiStore.user.type === 'starter') {
              startProCheckout({ uiStore, t })
              return
            }
            group.analysis.exportExcel(group.name)
          }}
        >
          <HugeiconsIcon icon={FileSpreadsheetIcon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.EXCEL_EXPORT')}</span>
          {uiStore.user && uiStore.user.type === 'starter' &&
            <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
        </button>
        <ExportKMZButton lgIcon item={geopolygon} />
        <button
          className='delete'
          onClick={(e) => {
            e.stopPropagation()
            uiStore.openDeletePrompt({
              style: {
                width: 340
              },
              position: 'right-start',
              selector: '.tools.popup-menu',
              text: (
                <DeleteItemPrompt
                  item={group}
                  itemType='region'
                  title={t('GLOBAL.DELETE_REGION_Q', { defaultValue: 'Delete region?' })}
                  itemName={geopolygon.name}
                  description={t('GLOBAL.DELETE_REGION_DESC', { defaultValue: 'This region and its saved data will be permanently removed.' })}
                  onSubmit={() => uiStore.deleteGeopolygon(group, geopolygon)}
                />
              )
            })
          }}
        >
          <HugeiconsIcon icon={Delete02Icon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.DELETE')}</span>
        </button>
      </section>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(OwnedGeopolygon)))
